import { makeGeoHooks } from './useGeoModeration';
import { listRestaurants, bulkRestaurants } from '../services/restaurants';

const hooks = makeGeoHooks('restaurants', {
  list: listRestaurants,
  bulk: bulkRestaurants,
});

export const useRestaurants = hooks.useList;
export const useBulkRestaurants = hooks.useBulk;
